import TalentTeam from "../models/TalentTeam";
import Client from "../models/Client";
import User from "../models/User";
import Meeting from "../models/Meeting";
import TalentCandidate from "../models/TalentCandidate";

const fetchTalentTeam = ({queryKey, signal}) => {
    const {
        teamId,
        ...params
    } = queryKey[1] || {};

    let auth = TB.auth()?.user?.();

    let queryString = ''

    if (auth && (auth.canManageTalent() || auth.isTalent() || auth.canManageClientResourceTalent())) {
        return TalentTeam.fetchTeamForTalent(teamId, {signal})
    }
}

const fetchTeam = ({queryKey, signal}) => {
    const {
        teamId,
        ...params
    } = queryKey[1] || {};

    let auth = TB.auth()?.user?.();

    let queryString = ''

    if (auth && auth.isClient?.() && params?.projectId) {
        queryString = `?project=${params?.projectId}`;
        return TalentTeam.fetchTeamForClient(teamId, queryString, {signal})
    }else if (auth && (auth.isTalent() || (!params.browse && auth.canManageClientResourceTalent()))) {
        return TalentTeam.fetchTeamForTalent(teamId, {signal})
    }


    return TalentTeam.fetchTeam(teamId,queryString, {signal})
}

const markProposalAsViewed = ({queryKey, signal}) => {
    const {client_id, project_id, position_id, candidate_id} = queryKey[1] || {};
    let endpoint = ''
    if (position_id) {
        endpoint =`/api/clients/${client_id}/projects/${project_id}/positions/${position_id}/candidates/${candidate_id}/track-proposal-view`
    }else {
        endpoint = `/api/clients/${client_id}/projects/${project_id}/team-candidates/${candidate_id}/track-proposal-view`
    }

    return new Promise(async (resolve) => {
        try {

            let request = TB.request(endpoint);

            let response = await request.post({signal});

            console.log('markedAsViewed', response)
            resolve(response)
        } catch (e) {
            console.warn(e)
            throw new Error(e)
        }

    });
}

const fetchClient = async ({queryKey, signal}) => {
    const clientId = queryKey[1];

    return Client.fetchClient(clientId, {signal})
}


const fetchTalent = async ({queryKey, signal}) => {
    const {
        profileId,
        project,
        position
    } = queryKey[1] || {};

    let params = {};
    if(project) {
        params.project = project;
    }

    if(position) {
        params.project_position = position;
    }

    let user = await User.fetchTalent(profileId, params, signal);
    if (user && user.job_candidate) {
        return TalentCandidate.make(TB.cloneDeep(user))
    }
    return user;
}

const fetchMeetings = ({queryKey, signal}) => {
    const {candidateId, positionId, projectId} = queryKey[1] || {};

    if (positionId) {
        return Meeting.fetchMeetingsForTalentPosition(positionId, candidateId, {signal})
    }
    if (projectId) {
        return Meeting.fetchMeetingsForProjectTeam(projectId, candidateId, {signal})
    }
    if (candidateId) {
        return Meeting.fetchMeetingsForOpportunityCandidate(candidateId, {signal})
    }
    return false;
}

const fetchTalentReviews = ({queryKey, signal}) => {
    const params = queryKey[1] || {};

    return TalentCandidate.fetchTalentReviews(params,{signal})
}

const fetchUserNotificationSettings = ({queryKey, signal}) => {

    let auth = TB.auth()?.user?.();
    if (!auth) {
        if (!laravel.auth_notification_settings || !laravel.auth_notification_settings_sections) {
            throw new Error("Missing auth notification settings");
        }

        return laravel.auth_notification_settings_sections;
    }
    return auth.getNotificationSettings({signal});
}

export {
    fetchMeetings,
    fetchTeam,
    fetchTalent,
    fetchClient,
    markProposalAsViewed,
    fetchTalentTeam,
    fetchTalentReviews,
    fetchUserNotificationSettings
}